export default "__VITE_ASSET__5a144a78__"